// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-red-envelope__result--fail .plv-iar-red-envelope__result__title{margin-top:4px;margin-bottom:32px}.plv-iar-red-envelope__result--fail .plv-iar-red-envelope__result__title--super{margin-top:76px;margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
